import React, { useCallback, useState } from 'react';
import { Container } from '@groupelacentrale/contact-storybook';
import { Link } from 'react-router-dom';
import { RegisterForm } from 'components';
import { ROUTES } from 'routes';
import { config } from 'config';
import { usePageTracking } from 'hooks';
import { TRACKING_PAGES } from 'api';
import './AuthPage.scss';

export const RegisterPage: React.FC = () => {
  usePageTracking(TRACKING_PAGES.INSCRIPTION);
  const [extendedInfo, setExtendedInfo] = useState<boolean>(false);

  const extend = useCallback(() => {
    setExtendedInfo(true);
  }, []);

  return (
    <Container shadowed paddings="mediumP" backgroundColor="bgWhite">
      <RegisterForm />
      <p>
        <span>
          <strong>Vous avez déjà un compte LaCentrale ?</strong>
        </span>
        &nbsp;
        <Link to={ROUTES.login}>Connexion</Link>
      </p>
      {!extendedInfo && (
        <p className="more-info" onClick={extend}>
          Les données que vous renseignez dans ce formulaire sont traitées par Groupe LaCentrale en qualité de
          responsable de traitement. L&apos;ensemble de ces données est obligatoire.
          <br />
          <span>Pour en savoir plus</span>
        </p>
      )}
      {extendedInfo && (
        <>
          <p className="more-info">Les données personnelles transmises par vos soins sont utilisées à des fins de :</p>
          <ul className="list">
            <li>
              Création de votre compte sur La Centrale, ce qui vous permet par exemple de créer des alertes pour
              recevoir par email des offres corresponsant à vos besoins, de conserver les annonces qui vous interessent
              ou, de déposer des annonces.
            </li>

            <li>Gestion de votre relation commerciale avec Groupe LaCentrale.</li>

            <li>Lutte anti-fraude.</li>
          </ul>
          <p className="more-info">
            Vous disposez d&apos;un droit d&apos;accès, de rectification, d&apos;effacement de ces données, d&apos;un
            droit de limitation du traitement, d&apos;un droit d&apos;opposition, du droit à la portabilité de vos
            données et du droit d&apos;introduire une réclamation auprès d&apos;une autorité de contrôle (en France, la
            CNIL). Vous pouvez également retirer à tout moment votre conscentement au traitement de vos données. Plus
            d&apos;informations sur le traitement de vos données: &nbsp;
            <a href={`${config.URL_LACENTRALE}informations/politique-confidentialite`}>
              https://www.lacentrale.fr/informations/politique-confidentialite
            </a>
          </p>
        </>
      )}
    </Container>
  );
};
